import { defineMessages } from "react-intl"

export const badgeMessages = defineMessages({
    //onboarding statuses
    inProgress: {
        id:"listing.labels.type.onboarding_in_progress_label",
        defaultMessage:"In Progress"
    },
    created: {
        id:"listing.labels.type.onboarding_created_label",
        defaultMessage:"Created"
    },
    declined: {
        id:"listing.labels.type.onboarding_declined_label",
        defaultMessage:"Declined"
    },
    inReview: {
        id:"listing.labels.type.onboarding_in_review_label",
        defaultMessage:"In Review"
    },
    processing: {
        id:"listing.labels.type.onboarding_processing_label",
        defaultMessage:"Processing"
    },
    completed: {
        id:"listing.labels.type.onboarding_completed_label",
        defaultMessage:"Completed"
    },

    //payment account statuses
    active: {
        id:"listing.labels.type.payment_account_active_label",
        defaultMessage:"Active"
    },
    deactivated: {
        id:"listing.labels.type.payment_account_deactivated_label",
        defaultMessage:"Deactivated"
    },
    pending: {
        id:"listing.labels.type.payment_account_pending_label",
        defaultMessage:"Pending"
    },
    suspended: {
        id:"listing.labels.type.payment_account_suspended_label",
        defaultMessage:"Suspended"
    },
    onboarding: {
        id:"listing.labels.type.payment_account_onboarding_label",
        defaultMessage:"Onboarding"
    },

    //terminal statuses
    paired: {
        id: "payment_processing.terminal_badges.paired",
        defaultMessage: "Paired",
    },
    inUse: {
        id: "payment_processing.terminal_badges.in_use",
        defaultMessage: "In Use",
    },
    notInUse: {
        id: "payment_processing.terminal_badges.not_in_use",
        defaultMessage: "Available",
    }
})


// WEBPACK FOOTER //
// ./src/payment-processing/components/BadgeMessages.ts